// assets/controllers/print_tooltip_controller.js
import { Controller } from '@hotwired/stimulus';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class extends Controller {
    connect() {
        const link = this.element.querySelector('.print-link');

        if (!link || !link.classList.contains('disabled')) {
            return;
        }

        const tooltipContent = link.getAttribute('data-tippy-content');

        if (!tooltipContent) {
            return;
        }

        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        tippy(link, {
            content: tooltipContent,
            placement: 'bottom',
            arrow: true,
            theme: 'print-tooltip',
            trigger: isMobile ? 'click' : 'mouseenter focus',
            interactive: true,
            hideOnClick: isMobile,
            offset: isMobile ? [0, 8] : [-50, 8],
            onCreate(instance) {
                instance.popper.style.fontWeight = '600';
            }
        });
    }
    handleClick(event) {
        if (event.currentTarget.classList.contains('disabled')) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
